// src/index.ts
import { extendBaseTheme } from "@stepstone-genesis/dresscode-base";
import { catererglobal as baseCatererGlobalTheme } from "@stepstone-genesis/design-tokens";
var catererglobal = extendBaseTheme("catererglobal", baseCatererGlobalTheme);
export {
  catererglobal
};
